var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "transition",
    { attrs: { name: "fast-fade" } },
    [
      _vm.tab != null
        ? _c(
            "w-col",
            { staticClass: "darken-col", attrs: { xs: "9" } },
            [
              _c(
                "w-container",
                { staticClass: "content" },
                [
                  _c(
                    "transition",
                    { attrs: { name: "fast-fade", mode: "out-in" } },
                    [
                      _c(
                        "div",
                        {
                          key: _vm.tab,
                          style: {
                            flexShrink: 1,
                            flexGrow: 1,
                            maxHeight: "100%",
                          },
                        },
                        [_vm._t("default")],
                        2
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }